import { createFocusTrap } from 'focus-trap'

export default () => ({
    open: false,

    init() {
        const focusTrap = createFocusTrap(this.$el, {
            clickOutsideDeactivates: true,
            onActivate: () => (this.open = true),
            onDeactivate: () => (this.open = false),
        })

        this.$watch('open', (open) => {
            if (open) {
                focusTrap.activate()
            } else {
                focusTrap.deactivate()
            }
        })
    },
})
